module.exports = __webpack_public_path__ + "static/media/eCom-el-hk.3682fd5e.svg";